import { FC } from 'react';
import Link from 'next/link';

interface IBreadcrumbs {
  firstPageName: string;
  secondPageName?: string;
  thirdPageName?: string;
  firstPageAlias?: string;
  secondPageAlias?: string;
}

const Breadcrumbs: FC<IBreadcrumbs> = ({ firstPageName, secondPageName, thirdPageName, firstPageAlias, secondPageAlias }) => {
  return (
    <ul className="breadcrumbsList">
      <li className="breadcrumbsList__item">
        <Link prefetch={false} className="breadcrumbsList__itemLink" href="/">
          Главная
        </Link>
      </li>
      <li className="breadcrumbsList__item">
        {!!firstPageAlias ? (
          <Link prefetch={false} className="breadcrumbsList__itemLink" href={`${firstPageAlias}`}>
            {firstPageName}
          </Link>
        ) : (
          <>{firstPageName}</>
        )}
      </li>
      {!!secondPageName && (
        <li className="breadcrumbsList__item">
          {!!secondPageAlias ? (
            <Link prefetch={false} className="breadcrumbsList__itemLink" href={`${secondPageAlias}`}>
              {secondPageName}
            </Link>
          ) : (
            <>{secondPageName}</>
          )}
        </li>
      )}
      {!!thirdPageName && (
        <li className="breadcrumbsList__item">
          <span className="breadcrumbsList__itemTxt">{thirdPageName}</span>
        </li>
      )}
    </ul>
  );
};

export default Breadcrumbs;
